// 带条件目标状态
import React from 'react'
import { connect } from 'react-redux'
import { nullDate, TDate } from '../../public/utility'
import { hasChangedValues } from '../../public/utility/formValues'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, addListItemsFromListItems, resetListValues, isListValuesChanged, cloneListItem } from '../../public/utility'

class ProcessInputParaSetDiv extends React.Component {
	state = {
		changedValues基本信息: {},
	}

	componentDidMount = () => {
		this.doGetProcessInputPara(this.props.id)
	}
	componentWillUnmount = () => {
		this.unmount = true
	}
	doGetProcessInputPara = (id) => {
		Tyan.doPostEvent({
			event: 'GetProcessInputPara',
			data: { id },
			onEnd: ({ errorMessage, initValues基本信息 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					this.setState({ id, initValues基本信息, changedValues基本信息: {} })
				}
			}
		})
	}

	handlerSave = () => {
		const { ProcessOperateID, onRefresh, onClose } = this.props
		const { id, changedValues基本信息, initValues基本信息 } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		Tyan.doPostEvent({
			event: 'SaveProcessInputPara',
			data: { id, changedValues基本信息: values },
			onEnd: ({ id, errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('保存成功')
					onRefresh && onRefresh()
					onClose && onClose()
				}
			}
		})
	}

	handlerDelete = () => {
		const { id } = this.state
		const { onRefresh, onClose } = this.props

		Tyan.pubForm.showConfirm('确定要删除？', () =>
			Tyan.doPostEvent({
				event: 'DeleteProcessInputPara',
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						onRefresh && onRefresh()
						onClose && onClose()
					}
				}
			}))
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	bSave = () => {
		const { initValues基本信息, changedValues基本信息 } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		return Object.keys(changedValues基本信息).length > 0 && values.输入方式
	}

	fieldset基本信息 = () => {
		const { initValues基本信息, changedValues基本信息 } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		return [
			{ _text: '表单项名称', disabled: true, minWidth: '95%' },
			{ _select: '输入方式', required: true, options: ['文本输入', '多行文本输入', '整型输入', '浮点输入', '下拉选择', '单选', '复选', '人员单选', '人员复选', '部门选择控件', '日期控件', '时间控件', '自动计算', '附件', '签名', '显示控件', '须知控件', '年月控件', '全部部门选择控件'], minWidth: '95%' },
			{ _text: '内容', minWidth: '95%', maxRows: 5, richtext: true, cdt: () => ['显示控件', '须知控件'].indexOf(values.输入方式) > -1 },
			{ _text: '内容', minWidth: '95%', cdt: () => ['显示控件', '须知控件'].indexOf(values.输入方式) == -1 },
			{ _text: '默认值', minWidth: '95%' },
			{ _int: '默认行数', minWidth: '95%', cdt: () => values.输入方式 == '多行文本输入' },
			{ _int: '选项宽度', minWidth: '95%', cdt: () => ['复选', '单选'].indexOf(values.输入方式) > -1 },
			{ _int: '小数位数', minWidth: '95%', cdt: () => ['浮点输入'].indexOf(values.输入方式) > -1, textAlign: 'left' },
			{ _radio: '是否复选', items: ['是', '否'], minWidth: '95%', cdt: () => values.输入方式 == '下拉选择' },
		]
	}

	render() {
		const { showMessage: Message, showBody: Body } = this.props
		const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
		if (errorMessage) return Tyan.pubForm.showError(errorMessage)
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		return <Body data={this} minWidth="800" maxWidth="1100"
			controls={
				[
					{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), },
					{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				]}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
				]}
		/>
	}
}

export default connect()(ProcessInputParaSetDiv)